import { TableSkeleton } from '@common/components/skeleton/TableSkeleton';
import { IUserListingModel } from '@common/models';
import { UserSearchStore } from '@hospital/stores';
import classNames from 'classnames';
import { chain } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import { Table } from 'react-bootstrap';


const RenderTableHeader = (hasEmailColumn?: boolean, combineFirstLastName?: boolean) => (
    <tr key={"header"} className="">
        {
            !combineFirstLastName &&
            <>
                <th>First Name</th>
                <th>Last Name</th>
            </>
        }
        {
            combineFirstLastName &&
            <th>Name</th>
        }
        <th>Primary Role</th>
        <th>Universal Provider Id</th>
        {
            !hasEmailColumn &&
            <th>Email Address</th>
        }
        <th>Active</th>
        <th className="action text-center">Actions</th>
    </tr >);

export interface IUsersTableProps {
    userSearchStore: UserSearchStore,
    onClick: (userId: number) => void,
    noUsersMessage?: string,
    hideEmail?: boolean,
    combineFirstLastName?: boolean
}

const convertNameForPrefix = (user: IUserListingModel) => {
    const drRoles = ["veterinarian", "petpass_dvm"];
    var isDvm = chain(user.roles.split(",")).some(r => drRoles.includes(r.toLowerCase().trim())).value();
    return (isDvm ? 'Dr. ' : '') + user.firstName + ' ' + user.lastName;
};

export const UsersTable = observer(({ userSearchStore, onClick, noUsersMessage, hideEmail, combineFirstLastName }: IUsersTableProps) => {
    const rows = userSearchStore.searchResults.results.map((u, index) => (
        <tr key={`${u.userId}_${index}`}
            className={classNames("border-default", "cursor-pointer")}
            onClick={() => onClick(u.userId)}>
            {
                !combineFirstLastName &&
                <>
                    <td>{u.firstName}</td>
                    <td>{u.lastName}</td>
                </>
            }
            {
                combineFirstLastName &&
                <>
                    <td><span>{convertNameForPrefix(u)}</span></td>
                </>
            }

            <td>{u.roles?.split(',').map(r => r.trim()).filter(r => !r.startsWith("PetPass"))[0]}</td>
            <td>{u.universalProviderId}</td>
            {
                !hideEmail &&
                <td>{u.emailAddress}</td>
            }
            <td><input type="checkbox" className="form-check-input" checked={u.isProfileActive} disabled={true} /></td>
            < td className="action text-center">
                <span><i className="fa fa-pencil" /></span>
            </td>
        </tr >
    ));

    const tableHeader = RenderTableHeader(hideEmail, combineFirstLastName);

    if (userSearchStore.isLoading)
        return (<TableSkeleton rows={10} cols={5}>{tableHeader}</TableSkeleton>);

    if (userSearchStore.searchResults.totalRecordCount === 0) {
        if (noUsersMessage)
            return <p>{noUsersMessage}</p>
        else
            return <p>No users match that combination of filters.</p>

    }

    return (
        <Table hover>
            <thead>
                {tableHeader}
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
});
